<template>
  <div v-if="mastercard" class="card card-rounded card-shadow border-0 mb-3">
    <div class="card-body">
      <div>
        <div class="small text-muted">{{ $t('SignMastercardAgreement.mastercard') }} {{ mastercard.cardNumber }}</div>
        <div class="py-1">
          <div class="small">{{ $t('SignMastercardAgreement.signWithPhone') }}</div>
          <button id="button-sign" @click="redirectToSigningPage" class="btn btn-sm btn-primary mt-3 mb-2 px-3">
            {{ $t('SignMastercardAgreement.continueToSigning') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import settings from '@shared/settings'
import store from '@shared/store'

export default {
  name: 'SignMastercardAgreement',
  data() {
    return {
      state: store.state,
      mastercard: undefined
    }
  },
  mounted() {
    if (settings.featureFlags.isMastercardWithdrawalEnabled()) {
      this.$http.get(`/api/customers/${this.state.currentUser.pin}/mastercard/mastercard-to-sign`).then(response => {
        this.mastercard = response.data.cards[0]
        const loadingError = response.data.error
        if (loadingError) {
          console.error('Failed to load mastercard signing info', loadingError)
        }
      })
    }
  },
  methods: {
    redirectToSigningPage() {
      this.$router.push({
        name: this.signingPageName(),
        params: { cardNumber: this.mastercard.cardNumber },
        query: { delivery: this.deliveryMethod() }
      })
    },
    deliveryMethod() {
      return this.mastercard.metadata?.address ? 'courier' : undefined
    },
    signingPageName() {
      return settings.isPkiSigningSupported() && settings.featureFlags.isPkiSigningEnabled()
          ? 'sign-card-agreement'
          : 'otp-sign-card-agreement'
    }
  }
}
</script>
